import {
  createMultiStyleConfigHelpers,
  StyleThemingProps,
} from '@chakra-ui/react'
import { textStyleKeys } from '~/themes/textStyles'
import { useCustomMultiStyleConfig } from '~/utils/chakraUtils'
import { getName } from '~/utils/objectUtils'

const ConfirmModalStyleParts = [
  'bodyContainer',
  'icon',
  'headerText',
  'bodyText',
  'footerContainer',
] as const

const helpers = createMultiStyleConfigHelpers(ConfirmModalStyleParts)

export const ConfirmModalStyle = helpers.defineMultiStyleConfig({
  baseStyle: {
    bodyContainer: {
      display: 'flex',
      flexDirection: 'column',
      gap: '0.5rem',
      alignItems: 'flex-start',
    },
    icon: {
      boxSize: '2rem',
      paddingBottom: '0.5rem',
    },
    headerText: {
      textStyle: textStyleKeys.Body1_Bold,
    },
    bodyText: {
      textStyle: textStyleKeys.Body1,
    },
    footerContainer: {
      justifyContent: 'flex-end',
      alignItems: 'center',
      gap: '0.625rem',
    },
  },
})

export const useConfirmModalStyle = (props?: StyleThemingProps) => {
  return useCustomMultiStyleConfig<typeof ConfirmModalStyleParts>(
    getName({ ConfirmModalStyle }),
    props,
  )
}
